import { en } from './en'
import { es } from './es'
import { fr } from './fr'
import { pt } from './pt'
import { de } from './de'
import { zh } from './zh'

export type Language = 'en' | 'es' | 'fr' | 'pt' | 'de' | 'zh'

export type Translations = typeof en

// Each locale is structurally a `Translations` but carries its own narrow
// string-literal types per module, so a direct cast is too narrow — widen
// through `unknown` (as the compiler suggests) to map them to the shared shape.
export const translations: Record<Language, Translations> = {
  en,
  es,
  fr,
  pt,
  de,
  zh,
} as unknown as Record<Language, Translations>

export const supportedLanguages: {
  code: Language
  name: string
  nativeName: string
}[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
]
